import { CategoryProvider } from "context/CategoryContext"
import BulletRed from "@components/shared-components/BulletRed"
import ButtonCloseQiscus from "@components/shared-components/ButtonCloseQiscus"
import QiscusOpen from "@components/shared-components/QiscusOpen"
import useButtonCloseQiscus from "lib/hooks/useButtonCloseQiscus"
import DrawerDefaultBlog from "../DefaultLayout/DrawerDefaultBlog"
import HeaderBlog from "../Header/blog"
import Footer from "../Footer"

function BlogLayout({ children, handleLogout }) {
  const { closeQiscusApp, isQiscusHidden, openQiscusApp, newMessages } = useButtonCloseQiscus()

  return (
    <>
      <style>
        {`
          ${
            isQiscusHidden
              ? "#qismo-widget {display:none} #qiscus-app-button-close { display:none }"
              : ""
          }
          .svelte-1xkyjie {
            display: none;
          }
        `}
      </style>
      <CategoryProvider>
        <HeaderBlog theme="light" isFixed handleLogout={handleLogout} />
        <div>
          <DrawerDefaultBlog handleLogout={handleLogout} />
        </div>
        <div className="h-[48px] lg:h-[132px]" />
        <BulletRed withNumberCount count={newMessages.length} isShow={!isQiscusHidden}/>
        <ButtonCloseQiscus closeQiscusApp={closeQiscusApp} />
        <div className="relative">{children}</div>
        {isQiscusHidden &&
          <QiscusOpen openQiscusApp={openQiscusApp}/>
        }
        <Footer />
      </CategoryProvider>
    </>
  )
}

export default BlogLayout
